/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SyncDaikinDevicesPayload } from 'api/actions/sync-daikin-devices/sync-daikin-devices-payload';
import { SyncDaikinDevicesPathParameters } from 'api/actions/sync-daikin-devices/sync-daikin-devices-path-parameters';
import { SyncDaikinDevicesResponse } from 'api/actions/sync-daikin-devices/sync-daikin-devices-response';

type SyncDaikinDevicesQueryParameters = Record<string, any>;

/**
 * The path of the SyncDaikinDevices action.
 */
export const syncDaikinDevicesActionPath = new SweetPath<keyof SyncDaikinDevicesPathParameters>(
  '/daikin/sync-devices',
  { path: '{param}' }
);

/**
 * Creates a contextualized SyncDaikinDevices actions.
 */
export default function createSyncDaikinDevicesAction(axios: AxiosInstance) {
  return function syncDaikinDevicesAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: SyncDaikinDevicesQueryParameters;
    payload: SyncDaikinDevicesPayload;
  }) {
    const path = syncDaikinDevicesActionPath.original;

    return axios.post<SyncDaikinDevicesResponse, SyncDaikinDevicesResponse, SyncDaikinDevicesPayload>(path, payload);
  };
}
